import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { MatDialog } from '@angular/material/dialog';
import { OrderDetailPopup } from './order-detail-popup/order-detail-popup';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/shared/config';
import { AuthService } from '../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { OrdersService } from 'src/app/services/orders.service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private destroyed = false;
  isLoading: boolean = true;

  topcards = [
    {
      id: 1,
      color: 'primary',
      title: 'Total Orders',
      subtitle: '0'
    },
    {
      id: 2,
      color: 'warning',
      title: 'Missing Payment',
      subtitle: '0',
    },
    {
      id: 3,
      color: 'accent',
      title: 'Timeout',
      subtitle: '0',
    }
  ];

  companies$ = new Observable();
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  gotoSystem: EventEmitter<any> = new EventEmitter<any>();
  updateCompany: EventEmitter<ActionButtonEvent> = new EventEmitter<ActionButtonEvent>();
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'orderNo',
      name: 'orderNo'
    },
    {
      columnId: 'name',
      name: 'System',
      listener: this.gotoSystem,

    },
    {
      columnId: 'product',
      name: 'Product'
    }, {
      columnId: 'orderDate',
      name: 'Time'
    }, {
      columnId: 'liveStatus',
      name: 'Live',
      hideOnMobile: true
    }, {
      columnId: 'paymentStatus',
      name: 'Payment'
    }, {
      columnId: 'status',
      name: 'Order'
    }, {
      columnId: 'user',
      name: 'User',
      hideOnMobile: true
    },
    {
      columnId: 'pay',
      name: 'Type'
    },
    {
      columnId: 'total',
      name: 'Amount'
    }
  ]

  constructor(private config: ConfigService, public authService: AuthService, private orderService: OrdersService, private router: Router, private route: ActivatedRoute, private dialog: MatDialog) {
    this.companies$ = this.orderService.getOrders$().pipe(map(data => {
      return data.map(item => {
        return {
          ...item,
          product: item['orderDetail'].map(detail => detail.name + " (" + detail.price + ")").join(", "),
          liveStatus: item['live'] ? 'Live' : ''
        }
      })
    }))

    this.rowActionButtons = [
      { icon: 'info', tooltip: 'Order Detail', eventEmitter: this.updateCompany }
    ]
  }

  ngOnInit() {
    this.updateCompany.pipe(takeUntil(this.destroy$)).subscribe(async event => {
      let data = event.eventData;
      if (data) {
        const userInfo = await firstValueFrom(this.authService.getUser$());
        const userRoles = Object.keys(userInfo || {}).filter(key => userInfo[key] === true);
        this.dialog.open(OrderDetailPopup, {
          width: '550px',
          disableClose: true,
          data: {
            ...data,
            roles: userRoles
          }
        });
      }
    });

    this.gotoSystem.pipe(takeUntil(this.destroy$)).subscribe(data => {
      const url = this.router.serializeUrl(this.router.createUrlTree([`/dashboard/sites/${data['siteId']}/system/${data['systemId']}`], { queryParams: { companyId: data['companyId'] } }));
      window.open(url, '_blank')
    });

    (async () => {
      let result = await this.orderService.getTotalOrders$();
      if (this.destroyed) return;
      let missingPayment = await this.orderService.getMissingPaymentOrders$("missingPayment");
      if (this.destroyed) return;
      let timeout = await this.orderService.getMissingPaymentOrders$("Timeout");
      if (this.destroyed) return;
      this.isLoading = false; // Data has arrived
      this.topcards[0].subtitle = `${result['count'].toString()}`;
      this.topcards[1].subtitle = missingPayment.toString();
      this.topcards[2].subtitle = timeout.toString();
    })();
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
  }
}

